
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { rtohrlyLoadsTbl } from '../Models/LoadsData';

@Injectable({
  providedIn: 'root'
})
export class RtoHrlyDemandService {

  RtoloadsData: Observable<Array<rtohrlyLoadsTbl>>;

  constructor(private http: HttpClient) { }

  GetRtoHrlyLoadDemand(): Observable<Array<rtohrlyLoadsTbl>> {

    this.RtoloadsData = this.http.get<Array<rtohrlyLoadsTbl>>('api/RtohrlyLoadsTbls')
      .pipe(
        catchError(this.handleError<rtohrlyLoadsTbl[]>('GetRtoHrlyLoadDemand', []))
      );
    return this.RtoloadsData;
  }


  /**
  * Handle Http operation that failed.
  * Let the app continue.
  * @param operation - name of the operation that failed
  * @param result - optional value to return as the observable result
  */
  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      console.error(`${operation} failed: ${error.message}`);

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }
}

